import { SetChargingProfile } from "../v2.3.0/chargingprofiles";
import { Cdr, Cdrs } from "./cdrs";
import {
  ActiveChargingProfileResult,
  ChargingProfileResponse,
  ChargingProfileResult,
  ClearProfileResult,
} from "./chargingprofiles";
import {
  CancelReservationCommand,
  CommandResponse,
  ReserveNowCommand,
  StartSessionCommand,
  StopSessionCommand,
  UnlockConnectorCommand,
} from "./commands";
import { OcpiCredentials } from "./credentials";
import { ClientInfo } from "./hubclientinfo";
import { Connector, Evse, Location, Locations } from "./locations";
import {
  FinancialAdviceConfirmation,
  FinancialAdviceConfirmations,
  Terminal,
  Terminals,
} from "./payments";
import { Session, Sessions } from "./sessions";
import { Tariff, Tariffs } from "./tariffs";
import { AuthorizationInfo, Token, Tokens } from "./tokens";
import { OcpiVersionDetails, OcpiVersions } from "./versions";

export const OcpiSchemas = {
  versions: OcpiVersions,
  versionDetails: OcpiVersionDetails,
  credentials: OcpiCredentials,
  location: Location,
  locations: Locations,
  evse: Evse,
  connector: Connector,
  session: Session,
  sessions: Sessions,
  cdr: Cdr,
  cdrs: Cdrs,
  tariff: Tariff,
  tariffs: Tariffs,
  token: Token,
  tokens: Tokens,
  authorizationInfo: AuthorizationInfo,
  commandResponse: CommandResponse,
  reserveNow: ReserveNowCommand,
  cancelReservation: CancelReservationCommand,
  startSession: StartSessionCommand,
  stopSession: StopSessionCommand,
  unlockConnector: UnlockConnectorCommand,
  chargingProfileResponse: ChargingProfileResponse,
  activeChargingProfileResult: ActiveChargingProfileResult,
  chargingProfileResult: ChargingProfileResult,
  clearProfileResult: ClearProfileResult,
  setChargingProfile: SetChargingProfile,
  clientInfo: ClientInfo,
  terminal: Terminal,
  terminals: Terminals,
  financialAdviceConfirmation: FinancialAdviceConfirmation,
  financialAdviceConfirmations: FinancialAdviceConfirmations,
};
